import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Box, Typography , Stack ,Button, Card, CardContent, Grid, useMediaQuery, Chip } from '@mui/material';
import { CloudDownload, HourglassEmpty, Phone, Email, AccountCircle, CheckCircle } from '@mui/icons-material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import imgUrl from '../assets/images/imgUrl';
import { useNavigate } from "react-router";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useSelector } from 'react-redux';
 
const imgUrls = [
  imgUrl.fincirc,
  imgUrl.balpharma,
  imgUrl.ecube,
  imgUrl.whiteSpoons,
  imgUrl.pharmveda,
  imgUrl.chablani,
  imgUrl.enersynk,
  imgUrl.pecan,
  imgUrl.kridzz,
  imgUrl.deal,
  imgUrl.blackSwan,
  imgUrl.kurves,
  imgUrl.siroya,
  imgUrl.stivaph,
];


const triangleItems = [
  {
    title: 'Intellectual depth',
    icon: <img src={imgUrl.peaceBulb}/>,
    bg: 'linear-gradient(135deg, #66d3f4, #203f4e)',
    textColor: 'white',
  },
  {
    title: 'Emotional appeal',
    icon: <img src={imgUrl.peaceHeart}/>,
    bg: '#D1DE5F',
    textColor: 'black',
  },
  {
    title: 'Practical realism',
    icon: <img src={imgUrl.peaceHand}/>,
    bg: 'linear-gradient(135deg, #66d3f4, #203f4e)',
    textColor: 'white',
  },
];

// peacekeeper pledge
const renderCircles = (count) =>
    [...Array(count)].map((_, index) => (
      <Grid item key={index}>
        <Card
          sx={{
            width: 70,
            height: 70,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 3,
          }}
        >
          <CardContent />
        </Card>
      </Grid>
));

/* UI revamp: 28 Gems section — Grid layout with card-style design */
const GemsGrid = () => {
  const isMobileGems = useMediaQuery('(min-width:320px) and (max-width:767px)');

  const gemsData = [
    {
      id: 'nations',
      title: 'WITH NATIONS',
      subtitle: 'Gems for Peace',
      accentColor: '#006d76',
      backgroundColor: '#f0f9fb',
      // icon: '🌍',
      items: [
        { title: 'Reduction of defence budgets', description: 'Redirecting resources toward development and welfare' },
        { title: 'Upholding human rights', description: 'Ensuring dignity and freedom for all people' },
        { title: 'Race, gender, caste, and culture equality', description: 'Embracing diversity as humanity\'s strength' },
        { title: 'Abolition of trafficking and child labour', description: 'Protecting the vulnerable from exploitation' },
        { title: 'Promotion of cross-cultural exchanges', description: 'Building bridges through travel and understanding' },
        { title: 'Inclusive constitutional identity', description: 'Ensuring representation for all within nations' },
        { title: 'Values-based education worldwide', description: 'Nurturing peaceful minds from childhood' }
      ]
    },
    {
      id: 'law',
      title: 'WITH LAW',
      subtitle: 'Gems for Peace',
      accentColor: '#399746',
      backgroundColor: '#f0f9f2',
      // icon: '⚖️',
      items: [
        { title: 'Justice', description: 'Fair treatment and equality for all' },
        { title: 'Integrity', description: 'Upholding moral and ethical principles' },
        { title: 'Freedom', description: 'The right to live without oppression or fear' },
        { title: 'Responsibility', description: 'Accountability for one\'s actions' },
        { title: 'Respect', description: 'Valuing the rights and dignity of others' },
        { title: 'Order', description: 'Maintaining societal structures and rules for peace' },
        { title: 'Compassion', description: 'Balancing law with empathy for humanity' }
      ]
    },
    {
      id: 'people',
      title: 'WITH PEOPLE',
      subtitle: 'Gems for Peace',
      accentColor: '#0b8270',
      backgroundColor: '#e8f5f3',
      // icon: '👥',
      items: [
        { title: 'Communication', description: 'Open dialogue that bridges understanding' },
        { title: 'Co-creation', description: 'Building together for shared prosperity' },
        { title: 'Clarity', description: 'Transparency in intentions and actions' },
        { title: 'Co-existence', description: 'Living harmoniously with differences' },
        { title: 'Character', description: 'Integrity that inspires trust' },
        { title: 'Calmness', description: 'Peaceful presence in interactions' },
        { title: 'Conscience', description: 'Moral compass guiding relationships' }
      ]
    },
    {
      id: 'oneself',
      title: 'WITH ONESELF',
      subtitle: 'Gems for Peace',
      accentColor: '#fcaf4a',
      backgroundColor: '#fff8e8',
      // icon: '⭐',
      items: [
        { title: 'Gratitude', description: 'Appreciation for life\'s blessings' },
        { title: 'Forgiveness', description: 'Releasing the burden of resentment' },
        { title: 'Love', description: 'The foundation of inner peace' },
        { title: 'Humility', description: 'Strength found in modesty' },
        { title: 'Giving', description: 'Joy in service to others' },
        { title: 'Patience', description: 'Trust in life\'s timing' },
        { title: 'Truth', description: 'Alignment with one\'s authentic self' }
      ]
    }
  ];

    return (
      <Box
        sx={{
          width: '100%',
          mx: 'auto',
          backgroundColor: '#fcfcfb',
        }}
        className="foundedGemssection"
      >
        {gemsData.map((gem, categoryIndex) => {
          const isTitleOnLeft = categoryIndex % 2 === 0;
          const titleOrder = isTitleOnLeft ? 1 : 2;
          const cardsOrder = isTitleOnLeft ? 2 : 1;

          return (
            <Box
              className="foundedGemboxes"
              key={gem.id}
              sx={{
                width: '100%',
                // mb: { xs: 6, sm: 8, md: 10 },
                backgroundColor: gem.backgroundColor,
                py: 6,
                px: 5,
                '&:last-child': {
                  mb: 0,
                },
              }}
            >
               <Box
                 sx={{
                   display: 'flex',
                   flexDirection: isMobileGems
                     ? 'column'
                     : (titleOrder === 1 ? 'row' : 'row-reverse'),
                   gap: { xs: 1.5, sm: 2, md: 3, lg: 4, xl: 6 },
                   alignItems: 'stretch',
                   width: '100%',
                 }}
               >
                 {/* Title Section - Position alternates */}
                 <Box
                   sx={{
                     width: isMobileGems ? '100%' : '25%',
                     flexShrink: 0,
                     display: 'flex',
                     flexDirection: 'column',
                     alignItems: isMobileGems ? 'center' : 'center',
                     textAlign: isMobileGems
                       ? 'center'
                       : (isTitleOnLeft ? 'left' : 'right'),
                     justifyContent: isMobileGems ? 'flex-start' : 'center',
                     mb: isMobileGems ? 2 : 0,
                   }}
                 >
                  {/* Icon */}
                  {/* <Box
                    sx={{
                      fontSize: { xs: '3rem', sm: '3.5rem', md: '4rem' },
                      mb: { xs: 1, sm: 1.5 },
                    }}
                  >
                    {gem.icon}
                  </Box> */}

                   {/* Large Number 7 */}
                   <Typography
                     sx={{
                       fontSize: { xs: '3rem', sm: '3rem', md: '4.5rem', lg: '6rem', xl: '7rem' },
                       fontWeight: 900,
                       lineHeight: 1,
                       color: gem.accentColor,
                       mb: { xs: 0.25, sm: 0.5, md: 1 },
                       fontFamily: 'var(--heading-font)',
                     }}
                   >
                     7
                   </Typography>

                   {/* Gems for Peace */}
                   <Typography
                     sx={{
                       fontSize: { xs: '1.25rem', sm: '1.125rem', md: '1.5rem', lg: '1.875rem', xl: '2.25rem' },
                       fontWeight: 100,
                       color: '#2c2e35',
                       mb: { xs: 0.25, sm: 0.5, md: 1 },
                       fontFamily: 'var(--secondary-font)',
                     }}
                     className='gemSubtitle'
                   >
                     {gem.subtitle}
                   </Typography>

                   {/* WITH [CATEGORY] */}
                   <Typography
                     sx={{
                       fontSize: { xs: '1rem', sm: '0.75rem', md: '0.875rem', lg: '1rem', xl: '1.125rem' },
                       fontWeight: 400,
                       color: '#7f8c8d',
                       textTransform: 'uppercase',
                       letterSpacing: '0.05em',
                     }}
                   >
                     {gem.title}
                   </Typography>
                 </Box>

                 {/* Cards Grid - Position alternates */}
                 <Box
                   sx={{
                     width: isMobileGems ? '100%' : '75%',
                     flex: 1,
                     minWidth: 0,
                     paddingRight: isMobileGems ? 0 : '20px',
                     mt: isMobileGems ? 1 : 0,
                   }}
                 >
                 <Box
                   sx={{
                     display: 'grid',
                     gridTemplateColumns: {
                       xs: '1fr',
                       sm: 'repeat(2, 1fr)',
                     },
                     gap: { xs: 1, sm: 1.5, md: 2.5, lg: 3 },
                     height: '100%',
                     alignContent: 'start',
                   }}
                 >
                  {gem.items.map((item, itemIndex) => (
                     <Card
                       key={itemIndex}
                       sx={{
                         backgroundColor: '#ffffff',
                         borderRadius: { xs: '8px', sm: '10px', md: '12px' },
                         boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                         p: { xs: 1, sm: 1.5, md: 2.5, lg: 3 },
                         display: 'flex',
                         alignItems: 'flex-start',
                         transition: 'all 0.2s ease',
                         '&:hover': {
                           boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
                           transform: 'translateY(-2px)',
                         },
                       }}
                     >
                       {/* Number */}
                       <Typography
                         sx={{
                           fontSize: { xs: '1.25rem', sm: '1.75rem', md: '2.25rem', lg: '3rem' },
                           fontWeight: 900,
                           lineHeight: 1,
                           color: gem.accentColor,
                           mr: { xs: 0.75, sm: 1.25, md: 1.5, lg: 2 },
                           fontFamily: 'var(--heading-font)',
                           flexShrink: 0,
                         }}
                       >
                         {itemIndex + 1}
                       </Typography>

                       {/* Title and Description */}
                       <Box sx={{ flex: 1, minWidth: 0 }}>
                         <Typography
                           sx={{
                             fontSize: { xs: '0.75rem', sm: '0.9375rem', md: '1.125rem', lg: '1.25rem' },
                             fontWeight: 700,
                             color: '#2c2e35',
                             mb: { xs: 0.25, sm: 0.5, md: 0.75 },
                             fontFamily: 'var(--default-font)',
                             lineHeight: 1.3,
                           }}
                         >
                           {item.title}
                         </Typography>
                         <Typography
                           sx={{
                             fontSize: { xs: '0.625rem', sm: '0.75rem', md: '0.875rem', lg: '1rem' },
                             fontWeight: 400,
                             color: '#7f8c8d',
                             lineHeight: 1.4,
                             fontFamily: 'var(--default-font)',
                           }}
                         >
                           {item.description}
                         </Typography>
                       </Box>
                     </Card>
                   ))}
                 </Box>
               </Box>
             </Box>
           </Box>
          );
        })}
      </Box>
    );
};

/* Metrics data for animated counter strip */
const metricsData = [
    { icon: '🖼️', label: 'Arts', value: 150 },
    { icon: '☕', label: 'Cafee', value: 1 },
    { icon: '🎓', label: 'Colleges', value: 120 },
    { icon: '🌍', label: 'Countries Covered', value: 72 },
    { icon: '🏢', label: 'Corporates', value: 200 },
    { icon: '🎊', label: 'Events', value: 4 },
    { icon: '🎁', label: 'Gifts', value: 12 },
    { icon: '🎫', label: 'Governing Council', value: 21 },
    { icon: '🌟', label: 'Influencers', value: 150 },
    { icon: '☮️', label: 'I Am Peacekeeper', value: 50000 },
    { icon: '💻', label: 'Online Courses (Man-Hours)', value: 3 },
    { icon: '🤝', label: 'Organisations', value: 300 },
    { icon: '🕊️', label: 'Peace Country Directors', value: 21 },
    { icon: '📚', label: 'Publications', value: 14 },
    { icon: '📰', label: 'Media (Articles)', value: 720 },
    { icon: '📬', label: 'Newsletters', value: 8 },
    { icon: '💖', label: 'Welfare Fund', value: 1000000 },
    { icon: '🏫', label: 'Schools', value: 500 },
    { icon: '🎵', label: 'Songs', value: 21 },
    { icon: '🏷️', label: 'Stickers', value: 74 },
    { icon: '📹', label: 'Zoom Sessions', value: 7 },
  ];

/* Animated Counter Strip Component */
const AnimatedCounterStrip = () => {
  const navigate = useNavigate();
  const [counters, setCounters] = useState({});
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  // Route mapping for each card (only cards with pages)
  const getCardRoute = (label) => {
    const routeMap = {
      'Arts': '/Arts-and-Publications',
      'Cafee': '/Cafee',
      'Colleges': '/Schools-Colleges-Universities',
      'Corporates': '/Corporates',
      'Events': '/Events',
      'Gifts': '/Gifts',
      'Influencers': '/Influencers',
      'Publications': '/Arts-and-Publications',
      'Welfare Fund (Unity Donation)': '/Welfare-Fund',
      'Schools': '/Schools-Colleges-Universities',
    };
    return routeMap[label] || null;
  };

  const animateCounters = useCallback(() => {
    const duration = 2500; // 2.5 seconds
    const startTime = Date.now();

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // Easing function for smooth animation
      const easeOutQuad = progress * (2 - progress);

      const newCounters = {};
      metricsData.forEach((metric) => {
        newCounters[metric.label] = Math.floor(metric.value * easeOutQuad);
      });
      setCounters(newCounters);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // Ensure final values are set
        const finalCounters = {};
        metricsData.forEach((metric) => {
          finalCounters[metric.label] = metric.value;
        });
        setCounters(finalCounters);
      }
    };

    requestAnimationFrame(animate);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            animateCounters();
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasAnimated, animateCounters]);

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M+';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K+';
    }
    return num.toString();
  };

  // Theme colors for alternating cards
  const getCardColors = (index) => {
    const colors = [
      { bg: '#fffef5', iconBg: '#fed304', textColor: '#2c2e35', countColor: '#fed304' }, // Yellow theme
      { bg: '#f0f9f7', iconBg: '#82eddd', textColor: '#2c2e35', countColor: '#0b8270' }, // Green theme
      { bg: '#fff8e8', iconBg: '#fcaf4a', textColor: '#2c2e35', countColor: '#fcaf4a' }, // Orange theme
      { bg: '#e8f4f8', iconBg: '#549ef2', textColor: '#2c2e35', countColor: '#549ef2' }, // Blue theme
      { bg: '#f5f8e8', iconBg: '#a0cf76', textColor: '#2c2e35', countColor: '#399746' }, // Light green theme
    ];
    return colors[index % colors.length];
  };

  return (
    <Box
      className="mainCounterbox"
      ref={sectionRef}
      sx={{
        py: 6,
        px: 4,
        backgroundColor: '#fff',
      }}
    >
      {/* Title */}
      <Typography
        variant="h5"
        sx={{
          fontSize: '40px',
          fontWeight: '400',
          color: '#0A8270',
          mb: 5,
          textAlign: 'center',
        }}
        className='headingFont green-title'
      >
        I Am Peacekeeper Movement Dashboard
      </Typography>

      <Box
        sx={{
          width: '100%',
          mx: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(2, 1fr)',
              sm: 'repeat(3, 1fr)',
              md: 'repeat(3, 1fr)',
              lg: 'repeat(4, 1fr)',
              xl: 'repeat(5, 1fr)',
            },
            gap: { xs: 2, sm: 2.5, md: 3 },
          }}
        >
          {metricsData.map((metric, index) => {
            const colors = getCardColors(index);
            const isLast = index === metricsData.length - 1;
            // Special color coordination for I Am Peacekeeper card
            const isPeacekeeperCard = metric.label === 'I Am Peacekeeper';
            // Cards that should show hourglass icon (coming soon)
            const comingSoonCards = ['Arts', 'Colleges', 'Corporates', 'Influencers', 'Organisations', 'Welfare Fund', 'Schools'];
            const isComingSoon = comingSoonCards.includes(metric.label);
            const iconBgColor = isPeacekeeperCard ? '#0b8270' : colors.iconBg;
            const cardRoute = getCardRoute(metric.label);
            const isClickable = cardRoute !== null;
            return (
              <Card
                key={index}
                {...(isClickable && { onClick: () => navigate(cardRoute) })}
                sx={{
                  borderRadius: { xs: '8px', sm: '10px', md: '12px' },
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  p: { xs: 0.5, sm: 0.75, md: 1.25, lg: 1.5 },
                  backgroundColor: colors.bg,
                  transition: 'all 0.3s ease',
                  minHeight: { xs: 70, sm: 80, md: 90 },
                  cursor: isClickable ? 'pointer' : 'default',
                  '&:hover': {
                    transform: { xs: 'none', sm: 'translateY(-4px)' },
                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.1)',
                  },
                  // Center the last card horizontally while keeping same width
                  gridColumn: isLast ? {
                    xs: '1 / span 1',      // 2 columns: start at 1
                    sm: '2 / span 1',      // 3 columns: center at column 2
                    md: '2 / span 1',      // 3 columns: center at column 2
                    lg: '1 / -1',         // 4 columns: span all columns for centering
                    xl: '1 / -1',         // 5 columns: span all columns for centering
                  } : 'auto',
                  // Center horizontally on desktop (width ~1517px) at 90% and 100% zoom
                  justifySelf: isLast ? {
                    lg: 'center',
                    xl: 'center',
                  } : 'auto',
                  width: isLast ? {
                    lg: 'calc((100% - 3 * 24px) / 4)', // One column width for 4 columns (accounting for 3 gaps of 24px each)
                    xl: 'calc((100% - 4 * 24px) / 5)', // One column width for 5 columns (accounting for 4 gaps of 24px each)
                  } : 'auto',
                  // Specific media queries for different resolutions
                  ...(isLast ? {
                    '@media (min-width: 1200px) and (max-width: 1600px)': {
                      gridColumn: '1 / -1',
                      justifySelf: 'center',
                      width: 'calc((100% - 3 * 24px) / 4)', // Match one column width exactly for 4 columns
                    },
                    // For Mac resolution 2560x1664 at 100% zoom (5 columns)
                    '@media (min-width: 1920px) and (max-width: 2560px)': {
                      gridColumn: '1 / -1',
                      justifySelf: 'center',
                      width: 'calc((100% - 4 * 24px) / 5)', // Match one column width exactly for 5 columns
                    },
                    // For 80% zoom on Mac (2560 * 0.8 = 2048px) - 5 columns
                    '@media (min-width: 1920px) and (max-width: 2100px)': {
                      gridColumn: '1 / -1',
                      justifySelf: 'center',
                      width: 'calc((100% - 4 * 24px) / 5)', // Match one column width exactly for 5 columns
                    },
                  } : {}),
                }}
              >
                {/* Icon on left */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: { xs: 40, sm: 50, md: 60, lg: 70 },
                    width: { xs: 40, sm: 50, md: 60, lg: 70 },
                    height: { xs: 40, sm: 50, md: 60, lg: 70 },
                    borderRadius: { xs: '8px', sm: '10px', md: '12px' },
                    backgroundColor: iconBgColor,
                    mr: { xs: 1.5, sm: 2, md: 2.5, lg: 3 },
                    fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem', lg: '3rem' },
                    flexShrink: 0,
                  }}
                >
                  {metric.icon}
                </Box>

                {/* Number and text on right */}
                <Box
                  sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    minWidth: 0, // Allows text to truncate properly
                  }}
                >
                  {isComingSoon ? (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        mb: { xs: 0.25, sm: 0.5 },
                        position: 'relative',
                      }}
                    >
                      <Box
                        sx={{
                          position: 'relative',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <HourglassEmpty
                          sx={{
                            fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2rem', lg: '2.2rem' },
                            color: colors.countColor,
                            position: 'relative',
                            zIndex: 1,
                          }}
                        />
                        {/* Sand dropping effect */}
                        <Box
                          sx={{
                            position: 'absolute',
                            top: '20%',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '4px',
                            height: '60%',
                            background: `linear-gradient(to bottom, ${colors.countColor} 0%, ${colors.countColor} 50%, transparent 50%, transparent 100%)`,
                            backgroundSize: '100% 200%',
                            animation: 'sandDrop 2s linear infinite',
                            opacity: 0.7,
                            zIndex: 0,
                            '@keyframes sandDrop': {
                              '0%': {
                                backgroundPosition: '0 0',
                              },
                              '100%': {
                                backgroundPosition: '0 100%',
                              },
                            },
                          }}
                        />
                        {/* Sand particles effect */}
                        <Box
                          sx={{
                            position: 'absolute',
                            top: '25%',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '2px',
                            height: '50%',
                            background: `repeating-linear-gradient(
                              to bottom,
                              ${colors.countColor} 0px,
                              ${colors.countColor} 2px,
                              transparent 2px,
                              transparent 4px
                            )`,
                            animation: 'sandParticles 1.5s linear infinite',
                            opacity: 0.5,
                            zIndex: 0,
                            '@keyframes sandParticles': {
                              '0%': {
                                transform: 'translateX(-50%) translateY(0)',
                                opacity: 0.5,
                              },
                              '100%': {
                                transform: 'translateX(-50%) translateY(100%)',
                                opacity: 0,
                              },
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 700,
                        color: colors.countColor,
                        mb: { xs: 0.25, sm: 0.5 },
                        fontSize: isPeacekeeperCard 
                          ? { xs: '0.9rem', sm: '1.1rem', md: '1.3rem', lg: '1.5rem' }
                          : { xs: '1.1rem', sm: '1.4rem', md: '1.75rem', lg: '2rem' },
                        fontFamily: 'var(--heading-font)',
                        lineHeight: 1.2,
                        whiteSpace: isPeacekeeperCard ? 'normal' : 'nowrap',
                        overflow: 'visible',
                        textOverflow: 'clip',
                        wordBreak: 'break-word',
                      }}
                    >
                      {isPeacekeeperCard
                        ? '2.1 Million+ Online'
                        : counters[metric.label] !== undefined
                        ? formatNumber(counters[metric.label])
                        : '0'}
                    </Typography>
                  )}
                  <Typography
                    variant="body2"
                    sx={{
                      color: colors.textColor,
                      fontSize: { xs: '0.85rem', sm: '0.95rem', md: '1.05rem', lg: '1.2rem' },
                      fontWeight: 500,
                      lineHeight: { xs: 1.2, sm: 1.3 },
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: { xs: 2, sm: 3 },
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {metric.label}
                  </Typography>
                </Box>
              </Card>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

const Home = () => {
  const navigate = useNavigate();
  const { isAuthenticated, currentUser } = useSelector((state) => state.auth);

  // Get user's display name
  const getUserDisplayName = () => {
    if (!currentUser) return '';
    return currentUser.name || currentUser.username || currentUser.email || '';
  };

  // Clear base_pay_amount from localStorage when home page loads
  useEffect(() => {
    localStorage.removeItem('base_pay_amount');
    localStorage.removeItem('base_pay_amount_from_quickinfo');
    console.log('Cleared base_pay_amount from localStorage on home page');
  }, []);

  return (

    <>
    {/* Home section */}
    <Box
      className="homeSectionBg commonBannerBg"
      sx={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        // position: 'relative',
        color: 'white',
        px: 2,
      }}
    >
      {/* Mini Header (Top-Left) */}
      <Box
        sx={{
          position: 'absolute',
          top: 80,
          left: 0,
          display: 'flex',
          alignItems: 'center',
        }}
      >
         <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
       
      </Box>

     

    
    </Box>

    {/* peaceful movement section */}
    <Box
      sx={{
        position: 'relative',
        px: 3,
        py: 6,
        textAlign: 'center',
        backgroundColor: '#fff',
        overflow: 'hidden',
      }}
    >
     
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          opacity: 0.2,
          zIndex: 0,
        }}
        className="peaceSectionBg"
      />

      {/* Text Content */}
      <Typography
        variant="h6"
        component="blockquote"
        sx={{
          fontWeight: 400,
          color: '#2c2e35',
          position: 'relative',
          zIndex: 1,
          maxWidth: 800,
          margin: '0 auto',
          lineHeight: 1.5,
          fontSize:'30px'
        }}
      >
        <span style={{ fontWeight: 'bold', color: '#399746' }}>
          I Am Peacekeeper Movement
        </span>{' '}
        signifies the world's mass grassroots Movement of Peace through the creation of the planet's largest collective of peace advocates.
      </Typography>
    </Box>

    {/* Peacekeeper Calendar Carousel Section */}
    <Box
      sx={{
        py: { xs: 4, sm: 5, md: 6 },
        px: { xs: 2, sm: 3, md: 5 },
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        background: 'linear-gradient(to bottom right, #ffffff 0%, #f0f9f2 100%)',
        position: 'relative',
      }}
    >
      {/* Featured Product Chip */}
      {/* <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <Chip
          label="Featured Product"
          sx={{
            backgroundColor: '#0A8270',
            color: '#fff',
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            fontWeight: 600,
            px: 2,
            py: 0.5,
            borderRadius: '20px',
          }}
        />
      </Box> */}

      {/* Title */}
      <Typography
        variant="h4"
        className='green-title'
        sx={{
          fontFamily: 'var(--heading-font)',
          fontWeight: 400,
          // color: '#006d76',
          textAlign: 'center',
          mb: 2,
          fontSize: { xs: '1.75rem', sm: '2.25rem', md: '2.75rem' },
        }}
      >
       I Am Peacekeeper Calendar 2026
      </Typography>

      {/* Description */}
      <Typography
        variant="body1"
        sx={{
          fontFamily: 'Trebuchet MS, sans-serif !important',
          fontWeight:600,
          // fontFamily: 'var(--default-font)',
          color: '#2c2e35',
          textAlign: 'center',
          maxWidth: '800px',
          mx: 'auto',
          px: 2,
          fontSize: { xs: '0.975rem', sm: '1.4rem'},
          lineHeight: 1.6,
          mb:2,
        }}
      >
        Your Values. Your Organisation. One meaningful Expression.
      </Typography>

       {/* Subtitle */}
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight:600,
                    fontFamily: 'var(--default-font)',
                    color: '#2c2e35',
                    textAlign: 'center',
                    mb: 3,
                    fontSize: { xs: '0.975rem', sm: '1.3rem' },
                    textAlign:'center',
                    px: { xs: 0, sm: '100px' }, 
                  }}
                >
                Introducing the Life’s Success Chemistry Calendar 2026 – a values-led calendar designed as a gift of purpose, now available in a customised print edition featuring your Organisation or Company Logo.
                </Typography>

      {/* Calendar Card Container */}
      <Box
        sx={{
          maxWidth: '1200px',
          mx: 'auto',
          px: { xs: 1, sm: 2, md: 3 },
        }}
      >
        <Card
          sx={{
            borderRadius: { xs: '16px', sm: '20px', md: '24px' },
            overflow: 'hidden',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
            backgroundColor: '#fff',
          }}
        >
          <Grid container spacing={0}>
            {/* Left Side - Image */}
            <Grid size={{ xs: 12, md: 6 }} sx={{mt:2, display:'flex',justifyContent:'center',alignItems:'center'}}>
              <Box
                sx={{
                  width: '100%',
                  backgroundColor: 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  overflow: 'visible',
                  p: 0,
                }}
              >
                {/* Calendar Image */}
                <Box
                  component="img"
                  src={imgUrl.calender}
                  alt="Peacekeeper Calendar"
                  sx={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'contain',
                    display: 'block',
                  }}
                />
              </Box>
            </Grid>

            {/* Right Side - Content */}
            <Grid size={{ xs: 12, md: 6 }} sx={{display:'flex', justifyContent:'center'}}>
              <Box
                sx={{
                  p: { xs: 3, sm: 5, md: 5, lg: 6 },
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  minHeight: { xs: 'auto', sm: 'auto', md: 'auto' },
                  height: 'auto',
                }}
              >
                {/* Calendar Title */}
                {/* <Typography
                  variant="h5"
                  sx={{
                    fontFamily: 'var(--heading-font)',
                    fontWeight: 400,
                    color: '#006d76',
                    mb: 0,
                    fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
                    textAlign:'center'
                  }}
                >
                
               

               

                {/* Order Information */}
                <Box sx={{  textAlign: 'center' }}>
                  


                  {/* Pricing Section */}
                  <Box
                    sx={{
                      backgroundColor: '#fff',
                      borderRadius: { xs: '10px', sm: '12px' },
                      overflow: 'hidden',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                      maxWidth: { xs: '100%', sm: '450px', md: '500px' },
                      mx: 'auto',
                      mb: 2,
                    }}
                  >
                    {/* Pricing Header */}
                    <Box
                      sx={{
                        backgroundColor: '#0A8270',
                        py: { xs: 1, sm: 1.25 },
                        textAlign: 'center',
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Trebuchet MS, sans-serif !important',
                          fontWeight: 600,
                          color: '#fff',
                          fontSize: { xs: '0.9375rem', sm: '1rem', md: '1.125rem' },
                        }}
                      >
                        Pricing
                      </Typography>
                    </Box>

                    {/* Pricing Content */}
                    <Box
                      sx={{
                        p: { xs: 2, sm: 2.5, md: 3 },
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: { xs: 2, sm: 2.5, md: 3 },
                      }}
                    >
                      {/* Standard Rate */}
                      <Box sx={{ flex: 1, textAlign: { xs: 'center', sm: 'left' } }}>
                        <Typography
                          sx={{
                            fontFamily: 'Trebuchet MS, sans-serif !important',
                            color: '#2c2e35',
                            fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.875rem' },
                            mb: 0.75,
                          }}
                        >
                          Standard Rate
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'Trebuchet MS, sans-serif !important',
                            fontWeight: 700,
                            color: '#0A8270',
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
                            mb: 0.5,
                          }}
                        >
                          USD $4 per copy
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'Trebuchet MS, sans-serif !important',
                            color: '#666',
                            fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.875rem' },
                          }}
                        >
                          INR ₹360
                        </Typography>
                      </Box>

                      {/* Volume Discount */}
                      <Box sx={{ flex: 1, textAlign: { xs: 'center', sm: 'left' } }}>
                        <Typography
                          sx={{
                            fontFamily: 'Trebuchet MS, sans-serif !important',
                            color: '#399746',
                            fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.875rem' },
                            mb: 0.75,
                          }}
                        >
                          Volume Discount
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'Trebuchet MS, sans-serif !important',
                            fontWeight: 700,
                            color: '#399746',
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
                            mb: 0.5,
                          }}
                        >
                          12% off
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'Trebuchet MS, sans-serif !important',
                            color: '#666',
                            fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.875rem' },
                          }}
                        >
                          on orders of 400+ copies
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Title */}
                  

                  {/* Contact Person Card */}
                  <Box
                    sx={{
                      borderRadius: { xs: '10px', sm: '12px' },
                      p: { xs: 0, sm: 0, md: 0 },
                      mb: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: { xs: 1.5, sm: 2 },
                      flexWrap: { xs: 'wrap', sm: 'nowrap' },
                      maxWidth: { xs: '100%', sm: '400px', md: '450px' },
                      mx: 'auto',
                    }}
                  >
                  
                    {/* Lady Icon */}
                    {/* <Box
                      sx={{
                        width: { xs: 35, sm: 40 },
                        height: { xs: 35, sm: 40 },
                        borderRadius: '50%',
                        backgroundColor: '#0A8270',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <AccountCircle sx={{ color: '#fff', fontSize: { xs: '1rem', sm: '1.5rem' } }} />
                    </Box> */}

                    {/* Contact Info */}
                    {/* <Box sx={{ textAlign: { xs: 'center', sm: 'left' }, minWidth: 0 }}> */}
                      {/* <Typography
                        variant="body2"
                        sx={{
                          fontFamily: 'Trebuchet MS, sans-serif !important',
                          color: '#666',
                          fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                          mb: 0.5,
                        }}
                      >
                        Orders managed by
                      </Typography> */}
                      <Typography
                        variant="h6"
                        className='orderContacttext'
                        sx={{
                          fontFamily: 'Trebuchet MS, sans-serif !important',
                          fontWeight: 800,
                          color: '#0A8270',
                          fontSize: { xs: '0.9375rem', sm: '1rem', md: '1.5rem' },
                          wordBreak: 'break-word',
                          '&': {
                            fontFamily: 'Trebuchet MS, sans-serif !important',
                          },
                        }}
                        style={{ fontFamily: 'Trebuchet MS, sans-serif !important' }}
                      >
                      To Place Order : Ms.Aline Fernandes
                      </Typography>
                    {/* </Box> */}
                  </Box>

                  {/* Contact Details */}
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: { xs: 1.5, sm: 2, md: 3 },
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    justifyContent: { xs: 'flex-start', sm: 'center' },
                    width: '100%',
                    maxWidth: { xs: '100%', sm: '600px', md: '700px' },
                    mx: 'auto',
                    mb: 3,
                    flexWrap: { xs: 'nowrap', sm: 'nowrap' },
                  }}>
                    {/* Mobile Number */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1rem' },
                        flex: { xs: '1 1 100%', sm: '0 1 auto' },
                        backgroundColor: '#0A8270',
                        px: { xs: 2.5, sm: 3, md: 2.5 },
                    py: { xs: 0.75, sm: 0.875, md: 1 },
                    borderRadius: '8px',
                      }}
                    >
                      <Phone sx={{ fontSize: { xs: '1rem', sm: '1.125rem' }, color: '#fff', flexShrink: 0 }} />
                      <Box
                        component="a"
                        href="https://wa.me/919890294587"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          ml: 0.5,
                          color: '#fff',
                          textDecoration: 'none',
                          '&:hover': {
                            opacity: 0.8,
                          },
                        }}
                      >
                        <WhatsAppIcon sx={{ fontSize: { xs: '1.125rem', sm: '1.25rem' }, flexShrink: 0 }} />
                      </Box>
                      <Typography
                        component="a"
                        href="tel:+919890294587"
                        sx={{
                          fontFamily: 'Trebuchet MS, sans-serif !important',
                          fontWeight: 600,
                          color: '#fff',
                          textDecoration: 'none',
                          fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1rem' },
                          whiteSpace: 'nowrap',
                          '&:hover': {
                            textDecoration: 'underline',
                            color: '#fff',
                          },
                        }}
                      >
                        +91 98902 94587
                      </Typography>
                      
                    </Box>

                    {/* Email */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1rem' },
                        flex: { xs: '1 1 100%', sm: '0 1 auto' },
                        backgroundColor: '#0A8270',
                        px: { xs: 2.5, sm: 3, md: 2.5 },
                    py: { xs: 0.75, sm: 0.875, md: 1 },
                    borderRadius: '8px',
                      }}
                    >
                      <Email sx={{ fontSize: { xs: '1rem', sm: '1.125rem' }, color: '#fff', flexShrink: 0 }} />
                      <Typography
                        component="a"
                        href="mailto:aline@i-am-peacekeeper.com"
                        sx={{
                          fontFamily: 'Trebuchet MS, sans-serif !important',
                          fontWeight: 600,
                          color: '#fff',
                          textDecoration: 'none',
                          fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1rem' },
                          wordBreak: { xs: 'break-all', sm: 'normal' },
                          whiteSpace: { xs: 'normal', sm: 'nowrap' },
                          '&:hover': {
                            textDecoration: 'underline',
                            color: '#fff',
                          },
                        }}
                      >
                         aline@i-am-peacekeeper.com
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Download Button */}
                <Button
                  variant="contained"
                  startIcon={<CloudDownload sx={{ fontSize: { xs: '1rem', sm: '1.125rem' } }} />}
                  onClick={() => {
                    const link = document.createElement('a');
                    link.href = '/Peacekeeper-calender-2026.pdf'; 
                    link.download = 'I Am Peacekeeper Movement - Calendar 2026.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                  sx={{
                    backgroundColor: '#0A8270',
                    color: '#fff',
                    fontFamily: 'var(--default-font)',
                    fontWeight: 600,
                    fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1rem' },
                    px: { xs: 2.5, sm: 3, md: 3.5 },
                    py: { xs: 0.75, sm: 0.875, md: 1 },
                    mb: 2,
                    borderRadius: '8px',
                    textTransform: 'none',
                    width: { xs: '100%', sm: 'auto' },
                    minWidth: { xs: '100%', sm: '180px', md: '200px' },
                    mx: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: { xs: 0.75, sm: 1 },
                    whiteSpace: 'nowrap',
                    '& .MuiButton-startIcon': {
                      marginRight: { xs: '6px', sm: '8px' },
                      marginLeft: 0,
                    },
                    '&:hover': {
                      backgroundColor: '#006d76',
                    },
                    boxShadow: '0 4px 12px rgba(10, 130, 112, 0.3)',
                  }}
                >
                  Download Calendar
                </Button>

                {/* Download Info */}
                {/* <Typography
                  variant="caption"
                  sx={{
                    fontFamily: 'var(--default-font)',
                    color: '#666',
                    mb: 3,
                    fontSize: { xs: '0.85rem', sm: '1rem' },
                    textAlign:'center'
                  }}
                >
                  Free PDF Download • High Quality Print
                </Typography> */}

                {/* Features */}
                <Box sx={{ display: 'flex',justifyContent: 'center', flexDirection: 'row', gap: 1.5 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: '#0A8270',
                      }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        fontFamily: 'var(--default-font)',
                        color: '#2c2e35',
                        fontSize: { xs: '0.875rem', sm: '1rem' },
                      }}
                    >
                      12 Months
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: '#006d76',
                      }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        fontFamily: 'var(--default-font)',
                        color: '#2c2e35',
                        fontSize: { xs: '0.875rem', sm: '1rem' },
                      }}
                    >
                      Inspirational Quotes
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Card>
      </Box>

      
                  {/* Warning Box */}
                  <Box
                    sx={{
                      backgroundColor: '#fff9e6',
                      borderRadius: { xs: '10px', sm: '12px' },
                      p: { xs: 2, sm: 2.5 },
                      mt: 3,
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: { xs: 1.5, sm: 2 },
                      maxWidth: { xs: '100%', sm: '600px', md: '700px' },
                      mx: 'auto',
                    }}
                  >
                    <CheckCircle sx={{ 
                      color: '#fcaf4a', 
                      fontSize: { xs: '1.5rem', sm: '1.75rem' },
                      flexShrink: 0,
                      mt: 0.25,
                    }} />
                    <Typography
                      sx={{
                        fontFamily: 'Trebuchet MS, sans-serif !important',
                        color: '#2c2e35',
                        fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                        lineHeight: 1.6,
                        flex: 1,
                      }}
                    >
                      This is a limited-time print window so please confirm your quantity early to secure production.
                    </Typography>
                  </Box>

    </Box>

    {/* peacekeeper triangle */}
     <Box
      sx={{
        py: 6,
        px: 5,
        paddingBottom: '0px',
        paddingLeft: '0px',
        paddingRight: '0px',
        textAlign: 'center',
        // backgroundColor: '#eef7e3', 
      }}
      className="peaceMakerTriangleBg"
    >
      {/* Title */}
      <Typography
        id="gems-heading"
        variant="h5"
        sx={{
          fontWeight: '400',
          color: '#0A8270',
          mb: 5,
        }}
        className='headingFont green-title'
      >
        Founded on the 28 Gems of World Peace:
        
      </Typography>

      {/* Triangle Circles */}
      {/* <Stack
        direction={{ xs: 'column', md: 'row' , sm: 'row' }}
        spacing={4}
        justifyContent="center"
        alignItems="center"
      >
        {triangleItems.map((item) => (
          <Box
            key={item.title}
            sx={{
              width: 160,
              height: 160,
              borderRadius: '50%',
              background: item.bg,
              color: item.textColor,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: 3,
              textAlign: 'center',
              p: 2,
            }}
          >
            {item.icon}
            <Typography variant="body1" sx={{ mt: 1, fontWeight: 500 }} className='peaceMakerCircleTitle'>
              {item.title}
            </Typography>
          </Box>
        ))}
      </Stack> */}

        {/* UI revamp: 28 Gems section — Grid layout with card-style design */}
        {/* 28 GEMS OF WORLD PEACE Section */}
    <Box className="gems-section" component="section" id="gems" aria-labelledby="gems-heading">
      {/* Grid Layout Container */}
      <GemsGrid />
    </Box>
      
    </Box>

    {/* Animated Counter Strip Section */}
    <AnimatedCounterStrip />   

  

    {/* peacekeeper patron */}

    <Box sx={{ textAlign: 'center', p: 4 }} className="peacekeeperPatronSection pledgeButtons">
      {/* Peacekeeper PATRON Section */}
     
      {/* <Grid container justifyContent="center" spacing={2} mb={5} mt={5}>
        {renderCircles(5)}
      </Grid> */}

      {/* Peacekeeper PARTNER Section */}
       {/* <img src={imgUrl.peaceIcon} className='w-100 peaceImg' mt={5}></img>
      <Typography variant="h6" sx={{ mb: 1 }} className='patronHeading green-title'>
        I Am Peacekeeper PARTNER:
       <br></br>
      
        Partners of Global Justice, <br></br> Love & Peace
        </Typography>
      <Grid container justifyContent="center" spacing={2} mb={5} mt={5}>
        {renderCircles(5)}
      </Grid> */}

      {/* logos partner section */}

      

      {/* Buttons */}
      <Grid container justifyContent="center" spacing={2} mb={5} mt={5}>
        <Grid>
          {isAuthenticated && currentUser ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
              
              <Button
                variant="contained"
                className='blueButton'
                onClick={() => navigate("/dashboard")}
              >
                Join the Movement
              </Button>
            </Box>
          ) : (
          <Button
            variant="contained"
            className='blueButton'
            onClick={() => navigate("/login")}
          >
            Join the Movement
          </Button>
          )}
        </Grid>
        <Grid>
       
          <Button
            variant="contained"
            className='blueButton'
            onClick={() => navigate("/pledge")}
          >
            Take I Am Peacekeeper Pledge
          </Button>
        </Grid>
      </Grid>
    </Box>
    

    </>
  );
};

export default Home;
